import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody43.css';

import clientimg from '../images/case-study-client43.webp'
import outcome from '../images/outcome43.webp'

import sm1 from '../images/cs43so1.webp'
import sm2 from '../images/cs43so2.webp'
import sm3 from '../images/cs43so3.webp'
import sm4 from '../images/cs43so4.webp'
import sm5 from '../images/cs43so5.webp'
import sm6 from '../images/cs43so6.webp'


const Casestudybody43 = () => {

    return (
        <>
        <section className='casestudybody43-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A hospitality group, fully owned by a sovereign wealth fund, focused on transforming historic and cultural sites into ultra-luxury boutique hotels </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>To bring consistency across its expanding portfolio, the client aimed to establish a unified framework for documenting key finance and accounting procedures. With multiple assets operating independently, the client required a common framework to streamline operations, ensure consistency and strengthen internal control</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody43-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Kick-off & Objective Alignment: </h4>
                          <p>Conducted an onboarding workshop with the client to align on expectations for developing a unified procedural framework, aimed at replacing<span style={{color:"#03A393",fontWeight:700}}> inconsistent asset-level practices</span> with <span style={{color:"#03A393",fontWeight:700}}> standardized documentation</span> and <span style={{color:"#03A393",fontWeight:700}}> execution</span></p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Virtual Data Room Management:</h4>
                          <p>Established and managed a secure virtual data room to organize <span style={{color:"#03A393",fontWeight:700}}> confidential client materials, including internal briefings, reference documents</span> and <span style={{color:"#03A393",fontWeight:700}}> supporting resources</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Standardized SOP Template:</h4>
                          <p>Developed a <span style={{color:"#03A393",fontWeight:700}}> standardized SOP</span> template to ensure consistency across all documentation. The template was reviewed and approved by the client prior to drafting <span style={{color:"#03A393",fontWeight:700}}> SOPs document</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>SOP Benchmarking & Alignment:</h4>
                          <p>Analysed existing finance and accounting procedures across the client's assets and conducted detailed benchmarking against <span style={{color:"#03A393",fontWeight:700}}> industry standards</span> and <span style={{color:"#03A393",fontWeight:700}}> regulatory requirements.</span> Consolidated these insights to structure SOP documents that align with best practices and ensure consistency</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>SOP Preparation & Review: </h4>
                          <p>Prepared a comprehensive set of SOPs covering key<span style={{color:"#03A393",fontWeight:700}}>  operational areas, including accounting, reporting</span> and <span style={{color:"#03A393",fontWeight:700}}> internal controls.</span> Each document was supported by <span style={{color:"#03A393",fontWeight:700}}> relevant annexures, form</span> and <span style={{color:"#03A393",fontWeight:700}}> reference materials & underwent detailed review</span> to ensure clarity, relevance and alignment with client requirements</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                        <img src={sm6} alt=''/>
                       </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody43-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Established a standardized procedural framework across client assets, streamlining finance and accounting functions. Delivered 30+ SOPs, reducing operational, financial and regulatory risk while strengthening internal controls, governance and scalability across future properties</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody43
